// const wordpress = window.name ? JSON.parse(window.name) : { front_url: '', api_url: '', nonce: '' };

export default {
  storageType: process.env.VUE_APP_STORAGE_TYPE || 'http',
  api_url: process.env.VUE_APP_API_URL || '',
  // base_url: wordpress.front_url,
  // base_url: process.env.BASE_URL
  // api_url: wordpress.api_url,
  // api_nonce: wordpress.nonce,
};
